import { render, staticRenderFns } from "./DevicesAndProducts.vue?vue&type=template&id=5b721c0c"
import script from "./DevicesAndProducts.vue?vue&type=script&lang=js"
export * from "./DevicesAndProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports